const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;

// Time left on a client link, for the inbox: "J-3" (days), "H-12" (hours, under 24h),
// "expired", or "" when the expiry is unknown.
export function linkTimeLeftLabel(expiresAtMs, nowMs = Date.now()) {
  if (!expiresAtMs) return "";
  const left = expiresAtMs - nowMs;
  if (left <= 0) return "expired";
  if (left < DAY_MS) return `H-${Math.ceil(left / HOUR_MS)}`;
  return `J-${Math.round(left / DAY_MS)}`;
}
